<template>
  <div v-if="selectedRegion" class="selected-region">
    {{ selectedRegion.title }}
    <svg-icon name="arrow-down" />
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "RegionSelectorToggle",
  computed: {
    selectedRegion() {
      return this.$store.state.selectedRegion;
    },
  },
});
</script>

<style scoped lang="scss">
.selected-region {
  @apply truncate flex items-center gap-2 bg-[#182828] px-3 py-3 rounded-2xl text-white text-[14px] leading-[21px];
  &:hover {
    @apply cursor-pointer bg-[#182828]/80;
  }
}
</style>
